var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 1.17139,
    width: 11.25,
    height: 11.25,
    rx: 2.625,
    fill: "#DB3959"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 1.17139,
    width: 11.25,
    height: 11.25,
    rx: 2.625,
    stroke: "#DB3959",
    strokeWidth: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12889_32956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91732 3.8797L3.08398 9.71303M3.08398 3.8797L8.91732 9.71303",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12889_32956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(2.5 3.29639)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCheckBox);
export default __webpack_public_path__ + "static/media/x-check-box.e504bdd3.svg";
export { ForwardRef as ReactComponent };